export function getNumber(value: any): number {
  return Number(
    (value || 0)
      .toString()
      .replace(/\s+/g, '')
      .replace(/,/g, '.')
  );
}
